import React, { Component, Fragment } from 'react';
import { Panel } from 'react-bootstrap';
import classNames from 'classnames';
import { isEqual } from 'lodash';

import PropTypes from 'prop-types';
import Notes from './notes';
import Attachments from './attachments';
import StatusHistory from './statusHistory';

class CollapseItem extends Component {
	shouldComponentUpdate = ({
		id, title, collapse, data, loading,
	}) => {
		const lastProps = this.props;
		return (
			!isEqual(lastProps.id, id)
			|| !isEqual(lastProps.title, title)
			|| !isEqual(lastProps.data, data)
			|| !isEqual(lastProps.collapse, collapse)
			|| !isEqual(lastProps.loading, loading)
		);
	};

	changeCollapseStatus = () => {
		const { collapse, id, changeCollapseStatus } = this.props;
		changeCollapseStatus(id, !collapse);
	}

	render() {
		const {
			collapse,
			title,
			id,
			data,
			panelClassName,
			titleIcon,
			loading,
			noCollapseIcon,
			titleClassName,
			titleIconClassName,
			downloadAllArray,
		} = this.props;
		return (
			<Fragment>
				<div
					className="padding-bottom-10 flex"
					onClick={this.changeCollapseStatus}
					role="button"
					onKeyPress={null}
					tabIndex={0}
				>
					<If condition={titleIcon}>
						<i className={`icon-${titleIcon} ${titleIconClassName} padding-right-10 padding-top-5`} />
					</If>
					<span className={`${titleClassName} flex-2`}>{ title }</span>
					<If condition={!noCollapseIcon}>
						<i className={classNames('padding-top-5 padding-right-5 fa', { 'fa-chevron-up' : collapse, 'fa-chevron-down' : !collapse })} />
					</If>
				</div>
				<Panel
					id={`collapsible-panel-${id}`}
					expanded={collapse}
					className={panelClassName}
					onToggle={() => {}} /* onToggle given to remove panel warning */
				>
					<Panel.Collapse>
						<Panel.Body>
							<Choose>
								<When condition={id === 'notes'}>
									<Notes
										data={data}
										loading={loading}
									/>
								</When>
								<When condition={id === 'attachments'}>
									<Attachments
										data={data}
										loading={loading}
										downloadAllArray={downloadAllArray}
									/>
								</When>
								<Otherwise>
									<StatusHistory
										data={data}
										loading={loading}
									/>
								</Otherwise>
							</Choose>
						</Panel.Body>
					</Panel.Collapse>
				</Panel>
			</Fragment>
		);
	}
}

CollapseItem.propTypes = {
	id                   : PropTypes.string,
	title                : PropTypes.string,
	collapse             : PropTypes.bool,
	loading              : PropTypes.bool,
	changeCollapseStatus : PropTypes.func,
	data                 : PropTypes.array,
	panelClassName       : PropTypes.string,
	noCollapseIcon       : PropTypes.bool,
	titleIcon            : PropTypes.string,
	titleIconClassName   : PropTypes.string,
	titleClassName       : PropTypes.string,
	downloadAllArray     : PropTypes.array,
};

CollapseItem.defaultProps = {
	id                   : '',
	title                : '',
	collapse             : false,
	changeCollapseStatus : undefined,
	data                 : [],
	panelClassName       : '',
	loading              : false,
	noCollapseIcon       : false,
	titleIcon            : '',
	titleIconClassName   : 'font-size-16',
	titleClassName       : 'font-size-16 color-dark',
	downloadAllArray     : [],
};

export default CollapseItem;
